module.exports = __webpack_public_path__ + "img/shop-service-filter-honda.d9d0ca53.png";